import React, {useState} from 'react';
import {ReportWidgetLoader} from '../ReportWidgetLoader';
import ArrowRight from '@svg/arrow-right-blue.svg?react';
import {DonutChart} from '@src/components/shared/DonutChart/DonutChart';
import {AppsFilter, ReportName} from '@src/utils/enums';
import {DirectionalWidgetProps} from '../types';
import {Link} from 'react-router-dom';
import './NetworkTrafficWidget.scss';
import {convertBytesUnits} from '@src/utils/convertBytesUnit';
import {TryAgainWidgetMessage} from '@src/components/shared/try-again-message/try-again-widget-message';
import AppsFilterSelect from '@src/components/shared/AppsFilterSelect/AppsFilterSelect';
import { useStores } from '@src/components/store';

export const NetworkTrafficWidget: React.FC<DirectionalWidgetProps> = (props) => {
    const { customerStore } = useStores();

    const chartColors = ['#AF29BB', '#91DC00', '#0057B8', '#009FDB', '#49EEDC'];
    const [appsFilter, setAppsFilter] = useState<AppsFilter>(AppsFilter.AllApps);
    const reportName = appsFilter === AppsFilter.AiApps ? 'aiNetworkTraffic' : 'networkTraffic';
    return (
        <ReportWidgetLoader hookProps={{...props, reportName}}>
            {(data, error) => {
                const totalTraffic = convertBytesUnits(data?.totalNetworkTraffic);

                const appsLegends = data?.topApps?.map((app: { name: string; networkTraffic: number }, idx: number) => {
                    const appData = convertBytesUnits(app.networkTraffic);
                    return (
                        <div className="legend-item" key={app.name}>
                            <span className="legend-color" style={{background: chartColors[idx % chartColors.length]}}/>
                            <div className="legend-text-block">
                                <span className="legend-value">{appData.value}{appData.unitName}</span>
                                <span className="legend-label">{app.name}</span>
                            </div>
                        </div>
                    );
                });

                return (
                    <div className="network-traffic-widget">
                        <div className="widget-header">
                            <div className="widget-title">Most used apps - {props.direction.toLowerCase()}</div>
                            <div className="widget-actions">
                                {customerStore.isPremium && <AppsFilterSelect value={appsFilter} onChange={setAppsFilter}/>}
                                <Link className="circle-nav"
                                      to={`/${props.customerId}/${props.serviceId}/insights/reports/${ReportName.NETWORK_TRAFFIC}`}
                                      state={{direction: props.direction, aiDefense: appsFilter === AppsFilter.AiApps}}>
                                    <ArrowRight/>
                                </Link>
                            </div>
                        </div>
                        {error ? <TryAgainWidgetMessage /> :
                        <div className="widget-content legend-chart-row">
                            <div className="legend">
                                {appsLegends}
                            </div>
                            <div className="donut-chart-container">
                                <DonutChart
                                    segments={data.topApps.map((app: {
                                        name: string;
                                        networkTraffic: number
                                    }, idx: number) => ({
                                        value: app.networkTraffic,
                                        color: chartColors[idx % chartColors.length],
                                    }))}
                                    total={totalTraffic.value}
                                    unit={totalTraffic.unitName}
                                    size={235}
                                />
                            </div>
                        </div>}
                    </div>
                );
            }}
        </ReportWidgetLoader>
    );
};
